export default __webpack_public_path__ + "static/media/burger.eabc8cc4.png";